/**
 * Free Remotion Template Component
 * ---------------------------------
 * This template is free to use in your projects!
 * Credit appreciated but not required.
 *
 * Created by the team at https://www.reactvideoeditor.com
 *
 * Happy coding and building amazing videos! 🎉
 */

"use client";

import { useCurrentFrame, interpolate, spring, useVideoConfig } from "remotion";

export default function LogoGlitchReveal() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // Decay factor: starts at 1 and goes to 0 over time
  const decay = interpolate(frame, [0, 30], [1, 0], {
    extrapolateRight: "clamp",
  });

  // Pseudo-random offsets using sin for deterministic rendering
  const redOffsetX = Math.sin(frame * 7.3) * 15 * decay;
  const redOffsetY = Math.sin(frame * 5.1) * 10 * decay;
  const greenOffsetX = Math.sin(frame * 11.7) * 15 * decay;
  const greenOffsetY = Math.sin(frame * 3.9) * 10 * decay;
  const blueOffsetX = Math.sin(frame * 9.2) * 15 * decay;
  const blueOffsetY = Math.sin(frame * 6.4) * 10 * decay;

  // Clean logo appears after glitch settles
  const cleanOpacity = spring({
    frame: Math.max(0, frame - 25),
    fps,
    config: { damping: 14, stiffness: 80, mass: 0.6 },
  });

  // Glow intensity increases as glitch settles
  const glowIntensity = interpolate(frame, [20, 40], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  // Channel separation opacity fades out as clean logo appears
  const channelOpacity = interpolate(frame, [20, 35], [0.7, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const logoStyle: React.CSSProperties = {
    width: "120px",
    height: "120px",
    borderRadius: "24px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
  };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        backgroundColor: "#111827",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {/* RGB Channel Copies */}
      <div
        style={{
          position: "relative",
          width: "120px",
          height: "120px",
        }}
      >
        {/* Red channel */}
        <div
          style={{
            ...logoStyle,
            background: "rgba(239, 68, 68, 0.6)",
            transform: `translate(${redOffsetX}px, ${redOffsetY}px)`,
            opacity: channelOpacity,
            mixBlendMode: "screen",
          }}
        >
          <span
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "1.8rem",
              fontWeight: "800",
              letterSpacing: "0.1em",
              fontFamily: "Inter, sans-serif",
            }}
          >
            LOGO
          </span>
        </div>

        {/* Green channel */}
        <div
          style={{
            ...logoStyle,
            background: "rgba(34, 197, 94, 0.6)",
            transform: `translate(${greenOffsetX}px, ${greenOffsetY}px)`,
            opacity: channelOpacity,
            mixBlendMode: "screen",
          }}
        >
          <span
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "1.8rem",
              fontWeight: "800",
              letterSpacing: "0.1em",
              fontFamily: "Inter, sans-serif",
            }}
          >
            LOGO
          </span>
        </div>

        {/* Blue channel */}
        <div
          style={{
            ...logoStyle,
            background: "rgba(59, 130, 246, 0.6)",
            transform: `translate(${blueOffsetX}px, ${blueOffsetY}px)`,
            opacity: channelOpacity,
            mixBlendMode: "screen",
          }}
        >
          <span
            style={{
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "1.8rem",
              fontWeight: "800",
              letterSpacing: "0.1em",
              fontFamily: "Inter, sans-serif",
            }}
          >
            LOGO
          </span>
        </div>

        {/* Clean logo */}
        <div
          style={{
            ...logoStyle,
            background: "linear-gradient(135deg, #4361ee, #7209b7)",
            opacity: cleanOpacity,
            boxShadow: `0 0 ${40 * glowIntensity}px rgba(67, 97, 238, ${0.5 * glowIntensity})`,
          }}
        >
          <span
            style={{
              color: "white",
              fontSize: "1.8rem",
              fontWeight: "800",
              letterSpacing: "0.1em",
              fontFamily: "Inter, sans-serif",
            }}
          >
            LOGO
          </span>
        </div>
      </div>

      {/* Company Name */}
      <h2
        style={{
          color: "white",
          fontSize: "2rem",
          fontWeight: "700",
          marginTop: "1.5rem",
          marginBottom: 0,
          fontFamily: "Inter, sans-serif",
          letterSpacing: "0.05em",
          opacity: cleanOpacity,
        }}
      >
        Company Name
      </h2>
      <p
        style={{
          color: "#93c5fd",
          fontSize: "1rem",
          marginTop: "0.5rem",
          fontFamily: "Inter, sans-serif",
          opacity: cleanOpacity,
        }}
      >
        Your tagline here
      </p>
    </div>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
